export default __webpack_public_path__ + "static/media/logo7.36ca0549.png";